interface JobExperienceLevel {
  seniority: string;
  description: string;
}

const JobExperienceLevelEnum = {
  ASSISTANCE: { seniority: 'Assistente', description: '' },
  INTERNSHIP: { seniority: 'Estágio', description: '' },
  ENTRY_LEVEL: { seniority: 'Júnior', description: '' },
  MID_LEVEL: { seniority: 'Pleno', description: '' },
  SENIOR_LEVEL: { seniority: 'Sênior', description: '' },
  DIRECTOR: { seniority: 'Diretor', description: '' },
  EXECUTIVE: { seniority: 'Executivo', description: '' },
};

export const jobExperienceLevelMap: Record<string, JobExperienceLevel> = {
  ...JobExperienceLevelEnum,
};

export const jobExperienceLevelOptions = Object.keys(
  JobExperienceLevelEnum
).map((key) => ({
  value: key,
  label: jobExperienceLevelMap[key].seniority,
}));

export const experienceDescription = (
  years: number | undefined,
  title: string | undefined,
  type: 'focus' | 'career'
) => {
  if (!title || years === undefined) return '';

  const suffix = type === 'focus' ? 'como' : 'em';

  const phrase =
    years === 0
      ? `Sem experiência necessária ${suffix} `
      : `${years}+ anos ${suffix} `;
  return `${phrase} ${title}`;
};
